﻿import { Vue, vuetify, MOUNT_APP, PageMixin } from '../Modules/page-mixin'

new Vue({
    vuetify,
    mixins: [PageMixin]
}).$mount(MOUNT_APP)
         